module.exports = __webpack_public_path__ + "static/media/genisis22.eee83b99.jpg";